import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Sticky from 'react-stickynode';
import { generateRandomId, StickyNavRenderer, StickyNavUpdater } from './helpers';
import './StickyNav.scss';

export default function StickyNav(props) {
    const [stickyNavState, setStickyNavState] = useState(() => ({
        logicalName: props.data.logicalName || 'default-logical-name-sticky-nav',
        navigation: props.data.nav,
        showExpandedNav: false,
        wrapperId: 'sticky-nav-inner-' + generateRandomId(),
        navId: 'nav-' + generateRandomId(),
        isStuck: false,
    }));

    const prevProps = useRef(props);

    useEffect(() => {
        if (prevProps.current !== props) {
            prevProps.current = props;
            setStickyNavState(prevState => ({
                ...prevState,
                logicalName: props?.data?.logicalName || 'default-logical-name-sticky-nav',
                showExpandedNav: false,
                navigation: props?.data?.nav,
                wrapperId: 'sticky-nav-inner-' + generateRandomId(),
                navId: 'nav-' + generateRandomId(),
            }));
        }
    }, [props]);

    const toggleExpandedNav = e => {
        e.preventDefault();
        setStickyNavState(prevState => ({
            ...prevState,
            showExpandedNav: !prevState.showExpandedNav,
        }));
    };

    const expandedNavFalse = () => {
        setStickyNavState({
            showExpandedNav: false,
        });
    };

    const { StickyNavMarkup } = StickyNavRenderer({
        stickyNavState,
        props,
        toggleExpandedNav,
        expandedNavFalse,
    });

    const wrapperClasses = classNames({
        'container-fluid': true,
        module: true,
        'sticky-nav': true,
        'product-nav': props.data.darkBlue || props.data.colouroptions === 'Dark Blue' || (props.data.productPage && !props.data.colouroptions),
        'is-stuck': stickyNavState.isStuck,
        'dark-blue': props.data.darkBlue || props.data.colouroptions === 'Dark Blue' || (props.data.productPage && !props.data.colouroptions),
    });

    return (
        <div className={wrapperClasses} id={stickyNavState.logicalName}>
            <StickyNavUpdater stickyNavState={stickyNavState} setStickyNavState={setStickyNavState} />
            <Sticky enabled={true} top={64} innerZ={52}>
                {StickyNavMarkup}
            </Sticky>
        </div>
    );
};